// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "chunks/" + "fetch-worker" + "." + "1b76af6e6dc6197e4c43" + ".js";
};